/* ============================================================
   Slot4ever — global theme JS (vanilla, no build)
   Cart drawer via Shopify Section Rendering API, hero slider,
   FAQ accordion, PLP filter popovers, PDP gallery + qty,
   mobile search toggle.
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.Slot4ever && Slot4ever.moneyFormat) || '{{amount}} €';
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount[a-zA-Z_]*\s*\}\}/, amount);  
  };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------------------------------------------------------
     CART DRAWER
     --------------------------------------------------------- */
  const CartDrawer = {
    open() {
      document.body.classList.add('cart-open');
      const d = $('#cart-drawer');
      if (d) d.setAttribute('aria-hidden', 'false');
    },
    close() {
      document.body.classList.remove('cart-open');
      const d = $('#cart-drawer');
      if (d) d.setAttribute('aria-hidden', 'true');
    },
    async refresh() {
      // Re-render the cart-drawer section markup from the server.
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = html.querySelector('#cart-drawer-inner');
        const current = $('#cart-drawer-inner');
        if (fresh && current) current.replaceWith(fresh);
      } catch (e) { /* silent — links still work as fallback */ }
      this.updateCount();
    },
    async updateCount() {
      try {
        const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        $$('[data-cart-total]').forEach((el) => { el.textContent = money(cart.total_price); });
      } catch (e) { /* noop */ }
    },
  };
  window.CartDrawer = CartDrawer;
  const MobileNav = {
    open() {
    document.body.classList.add('mobile-nav-open');
    const d = $('#mobile-nav');
    if (d) d.setAttribute('aria-hidden', 'false');
    },
    close() {
    document.body.classList.remove('mobile-nav-open');
    const d = $('#mobile-nav');
    if (d) d.setAttribute('aria-hidden', 'true');
    },
    };
    window.MobileNav = MobileNav;
  
  async function addToCart(id, qty = 1, btn) {
    if (!id) return;
    const label = btn && btn.textContent;
    if (btn) { btn.disabled = true; btn.dataset.loading = '1'; }
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
      });
      if (!res.ok) throw new Error('add failed');
      await CartDrawer.refresh();
      CartDrawer.open();
    } catch (e) {
      // Fallback: go to the product/cart so the user is never stuck.
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } finally {
      if (btn) { btn.disabled = false; delete btn.dataset.loading; if (label) btn.textContent = label; }
    }
  }

  async function changeLine(key, quantity) {
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await CartDrawer.refresh();
    } catch (e) { window.location.reload(); }
  }

  // Event delegation for cart interactions.
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); CartDrawer.open(); return; }

    if (e.target.closest('[data-cart-close]') || e.target.closest('.cart-overlay')) {
      CartDrawer.close(); return;
    }

    const add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(add.dataset.addToCart, Number(add.dataset.qty || 1), add);
      return;
    }

    const remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.dataset.lineRemove, 0); return; }

    const minus = e.target.closest('[data-line-minus]');
    if (minus) { e.preventDefault(); changeLine(minus.dataset.lineMinus, Number(minus.dataset.qty) - 1); return; }
    const plus = e.target.closest('[data-line-plus]');
    if (plus) { e.preventDefault(); changeLine(plus.dataset.linePlus, Number(plus.dataset.qty) + 1); return; }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') CartDrawer.close(); MobileNav.close(); });

  /* ---------------------------------------------------------
     HERO SLIDESHOW  (crossfade, autorotate 5s)
     --------------------------------------------------------- */
  function initSlideshow(root) {
    const slides = $$('.hero__slide', root);
    const dots = $$('.hero__dot', root);
    if (slides.length < 2) return;
    let i = 0, timer = null;
    const delay = Number(root.dataset.interval || 5000);
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const start = () => { stop(); if (delay > 0) timer = setInterval(() => show(i + 1), delay); };
    const stop = () => { if (timer) clearInterval(timer); };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    show(0); start();
  }

  /* ---------------------------------------------------------
     FAQ ACCORDION (one open at a time)
     --------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const q = e.target.closest('.faq__q');
    if (!q) return;
    const item = q.closest('.faq__item');
    const group = q.closest('[data-faq]') || document;
    const wasOpen = item.classList.contains('is-open');
    $$('.faq__item', group).forEach((it) => { it.classList.remove('is-open'); const ic = $('.ic', it); if (ic) ic.textContent = '+'; });
    if (!wasOpen) { item.classList.add('is-open'); const ic = $('.ic', item); if (ic) ic.textContent = '–'; }
  });

  /* ---------------------------------------------------------
     PLP INTRO — LEER MÁS / LEER MENOS
     --------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-readmore-toggle]');
    if (!btn) return;
    const open = btn.closest('[data-readmore]').classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
    btn.textContent = open ? btn.dataset.less : btn.dataset.more;
  });

  /* ---------------------------------------------------------
     BANNER DE COOKIES DE SHOPIFY — enlace a la política de privacidad
     Shopify lo pinta con el código de idioma completo (/pt-PT/…), que da 404:
     se cambia por la raíz del idioma de la visita (/pt/…) al pulsarlo.
     --------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('#shopify-pc__banner__body-policy-link');
    if (a) a.pathname = a.pathname.replace(/^\/[a-z]{2}-[A-Z]{2}\//, window.Shopify?.routes?.root || '/');
  }, true);

  /* ---------------------------------------------------------
     PLP FILTER POPOVERS
     --------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-filter-pill]');
    if (pill) {
      e.stopPropagation();
      const key = pill.dataset.filterPill;
      const pop = $(`[data-filter-pop="${key}"]`);
      const isOpen = pop && pop.style.display === 'flex';
      $$('[data-filter-pop]').forEach((p) => { p.style.display = 'none'; });
      $$('[data-filter-pill]').forEach((p) => p.classList.remove('is-active'));
      if (pop && !isOpen) { pop.style.display = 'flex'; pill.classList.add('is-active'); }
      return;
    }
    if (!e.target.closest('[data-filter-pop]')) {
      $$('[data-filter-pop]').forEach((p) => { p.style.display = 'none'; });
      $$('[data-filter-pill]').forEach((p) => p.classList.remove('is-active'));
    }
  });

  /* ---------------------------------------------------------
     PDP GALLERY + QUANTITY
     --------------------------------------------------------- */
  function initGallery(root) {
    const main = $('[data-gallery-main]', root);
    if (!main) return;
    $$('[data-gallery-thumb]', root).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.galleryThumb;
        if (src) main.src = src;
        $$('[data-gallery-thumb]', root).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    const wrap = (dec || inc).closest('.qty');
    const input = $('input', wrap);
    if (!input) return;
    let v = parseInt(input.value, 10) || 1;
    v = inc ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  /* ---------------------------------------------------------
     MEGA MENU + MOBILE HEADER
     --------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-mega-trigger]');
    const mega = trigger && document.getElementById(trigger.dataset.megaTrigger || 'mega-menu');
    if (trigger && mega) {
      e.stopPropagation();
      const open = mega.hasAttribute('hidden');
      $$('.mega').forEach((m) => m.setAttribute('hidden', ''));
      if (open) mega.removeAttribute('hidden');
      return;
    }
    if (!e.target.closest('.mega')) $$('.mega').forEach((m) => m.setAttribute('hidden', ''));
    const burger = e.target.closest('[data-mobile-nav]');
        if (burger) { if (document.body.classList.contains('mobile-nav-open')) MobileNav.close(); else MobileNav.open(); return; }
            if (e.target.closest('[data-mobile-nav-close]') || e.target.closest('.mobile-nav-overlay')) { MobileNav.close(); return; }
                const navToggle = e.target.closest('[data-nav-toggle]');
                    if (navToggle) { e.preventDefault(); const li = navToggle.closest('.mobile-nav__item'); if (li) li.classList.toggle('is-open'); return; }
  });

  /* ---------------------------------------------------------
     BOOT
     --------------------------------------------------------- */
  function boot() {
    $$('[data-slideshow]').forEach(initSlideshow);
    $$('[data-gallery]').forEach(initGallery);
    CartDrawer.updateCount();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Support Shopify theme editor: re-init when a section is reloaded.
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target;
    $$('[data-slideshow]', sec).forEach(initSlideshow);
    $$('[data-gallery]', sec).forEach(initGallery);
  });
})();
